export const ALL_TAG_NAME = 'All';
export const PLY_IDEA_PREFIX = '[';
export const PLY_IDEA_SUFFIX = ']';

/*
//TODO: revert to these values, and find a way to replace it in the service file, so that it can be used in the regex
// export const PLY_IDEA_PREFIX = '{{ply-idea-prefix}}';
// export const PLY_IDEA_SUFFIX = '{{ply-idea-suffix}}';
*/

export const PUBLIC_TYPE = 'public';
export const WORKSPACE_TYPE = 'workspace';
